/* global lang */
import React, { Component } from "react";
import Loop from "@material-ui/icons/Loop";

export default class RemoteVideoPlaceholder extends Component {
  constructor(props) {
    super(props);

    this.state = { usersCount: 0, ended: 1 };

    this.getOnlineUsers = this.getOnlineUsers.bind(this);
  }
  componentDidMount() {
    this.props.getOnlineUsers(this.getOnlineUsers);
    this.props.registerOnlineUsers(this.getOnlineUsers);
    this.timeout1 = setTimeout(() => {
              document.getElementById('counter_txt').innerHTML = '';
              this.setState({
                ended: 1
              })
              this.timeout2 = setTimeout(() => {
                this.setState({
                  ended: 2
                })
              }, lang.timeoutbyebye2)
            }, lang.timeoutbyebye)
  }
  
  componentWillUnmount() {
    if(this.timeout1)
      clearTimeout(this.timeout1);
    if(this.timeout2)
      clearTimeout(this.timeout2);
  }

  getOnlineUsers(usersCount) {
    this.setState({ usersCount });
  }

  renderPlaceholder() {
    if (this.props.searching && !this.props.disconnected) {
      return (
        <div>
          <h1>
            <h3 dangerouslySetInnerHTML={{__html: lang.searching}}></h3>
            <span role="img" aria-label="thinking">
              &#129300;
            </span>{" "}
          </h1>
          <Loop
            className="rotating"
            style={{ width: "50px", height: "50px" }}
          />
        </div>
      );
    }

    if (this.props.searching && this.props.disconnected) {
      return (
        <div>
          <h1>
            <h3 dangerouslySetInnerHTML={{__html: lang.stranger_disconnect}}></h3>
            <span role="img" aria-label="surprised">
              &#128550;
            </span>
          </h1>
          <h3 dangerouslySetInnerHTML={{__html: lang.click_next_continue}}></h3>
        </div>
      );
    }

    if (!this.props.searching) {
      return (
        <div>
          <h1>
            { false &&
              <React.Fragment>
                Welcome to VideoChat Roulette!{" "}
                <span role="img" aria-label="tongue">
                  &#128539;
                </span>
              </React.Fragment>
            }
          </h1>
          { false &&
            <h3>online users: {this.state.usersCount}</h3>
          }
          <h3 dangerouslySetInnerHTML={{__html: lang.waiting}}></h3>
        </div>
      );
    }
  }

  render() {
    let style = {
              height: '100%',
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              textAlign: 'center',
            
            };
            
    return (
      <React.Fragment>
        <div className="video remote">
          <div style={ style }>
            { this.state.ended == 1 &&
              <p className={ 'waiting_someone_new' } dangerouslySetInnerHTML={{__html: lang.waiting_someone_new}}>
              </p>
            }
            { this.state.ended == 2 &&
              <p className={ 'waiting_someone_new2' } dangerouslySetInnerHTML={{__html: lang.waiting_someone_new2}}>
              </p>
            }
            <p>&nbsp;</p>
            <div className="loader_container">
              <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
            </div>
          </div>
        </div>
        
        <div id="counter">
            <div id="counter_txt"></div>
        </div>
        </React.Fragment>
    );
  }
}
